(() => {
  if (window.RBNLProductDetails) return;
  const labels = {color:'Kleur',colour:'Kleur',size:'Afmetingen','material type':'Materiaal',material:'Materiaal',weight:'Gewicht',decibel:'Geluidsniveau','applicable handlebar diameter':'Stuurdiameter',brand:'Merk',capacity:'Inhoud',dimensions:'Afmetingen',model:'Model'};
  const specKeys = /^(color|colour|kleur|size|maat|afmetingen|dimensions|material(?: type)?|materiaal|weight|gewicht|decibel|geluidsniveau|applicable handlebar diameter|stuurdiameter|brand|merk|capacity|inhoud|model|type|voeding|batterij|accu|vermogen|waterbestendig|compatibiliteit|geschikt voor|aantal|voering|bevestiging|lengte|breedte|hoogte|diameter)$/i;
  const requests = new Map();
  function table(rows, heading = 'Specificaties') {
    const section = document.createElement('section'); section.className = 'rb-product-specs';
    const title = document.createElement('h3'); title.textContent = heading; section.append(title);
    const table = document.createElement('table'); table.setAttribute('aria-label', heading);
    const tbody = document.createElement('tbody'); table.append(tbody);
    rows.forEach(([key,value]) => { const row=document.createElement('tr'); const th=document.createElement('th');th.scope='row';th.textContent=labels[key.toLowerCase()]||key;const td=document.createElement('td');td.textContent=value;row.append(th,td);tbody.append(row); });
    section.append(table);return section;
  }
  function format(root) {
    if (!root) return;
    root.classList.add('rb-product-description');
    const rows=[];const nodes=[];
    root.querySelectorAll('p,li,div').forEach(node=>{
      if (node.closest('table,.rb-product-specs,.rb-shipping-preview') || node.querySelector('p,li,div,table,img,video,iframe')) return;
      const lines=node.innerHTML.split(/<br\s*\/?\s*>/i).map(line=>{const el=document.createElement('span');el.innerHTML=line;return el.textContent.replace(/\s+/g,' ').trim();}).filter(Boolean);
      const parsed=lines.map(line=>{const match=line.match(/^([^:：]{1,45})\s*[:：]\s*(.{1,350})$/);return match&&specKeys.test(match[1].trim())?[match[1].trim(),match[2].trim()]:null;});
      if(parsed.length && parsed.every(Boolean)){rows.push(...parsed);nodes.push(node);}
    });
    if (rows.length) {nodes[0].before(table(rows));nodes.forEach(node=>node.remove());}
  }
  async function loadSpecs(root, productUrl) {
    if (!root || !productUrl || root.querySelector('[data-rb-native-specs]')) return;
    let url;
    try {url=new URL(productUrl,location.origin);if(url.origin!==location.origin)return;url.search='';url.hash='';url.searchParams.set('section_id','rbnl-product-specifications');} catch{return;}
    if(!requests.has(url.href)) {
      const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),10000);
      requests.set(url.href,fetch(url.href,{signal:controller.signal}).then(r=>{if(!r.ok)throw new Error('Specifications unavailable');return r.text();}).finally(()=>clearTimeout(timeout)).catch(error=>{requests.delete(url.href);throw error;}));
    }
    try {
      const html=await requests.get(url.href);if(!root.isConnected)return;
      const doc=new DOMParser().parseFromString(html,'text/html');
      const native=doc.querySelector('[data-rb-native-specs]');
      if(native?.querySelector('tr')) {
        const destination = root.querySelector(':scope > .rb-detail-panel:last-child') || root;
        destination.prepend(native.cloneNode(true));
      }
    } catch { /* The original description and its specification tables remain readable. */ }
  }
  function shipping(root, scope=document) {
    if(!root || root.querySelector('.rb-shipping-preview'))return;
    const template=scope.querySelector('template[data-rb-shipping-preview]')||document.querySelector('template[data-rb-shipping-preview]');
    if(template)root.append(template.content.cloneNode(true));
  }
  let tabSequence = 0;
  function tabs(root) {
    if (!root || root.querySelector('[data-rb-detail-tabs]')) return;
    const specifications = [...root.querySelectorAll('.rb-product-specs,[data-rb-native-specs]')]
      .filter(node => !node.closest('details') && !node.parentElement.closest('.rb-product-specs,[data-rb-native-specs]'));
    root.querySelectorAll('table').forEach(node => {
      if (node.closest('details,.rb-product-specs,[data-rb-native-specs]')) return;
      const heading = node.previousElementSibling;
      if (heading && /^(specificaties|specifications|technische gegevens)\s*:?$/i.test(heading.textContent.trim())) specifications.push(heading, node);
    });
    if (!specifications.length) return;
    const specs = document.createElement('div');
    specifications.forEach(node => specs.append(node));
    if (!root.textContent.trim() && !root.querySelector('img,video')) { root.replaceChildren(specs); return; }
    const description = document.createElement('div');
    description.append(...root.childNodes);
    const nav = document.createElement('div');
    nav.dataset.rbDetailTabs = ''; nav.className = 'rb-detail-tabs';
    nav.setAttribute('role','tablist'); nav.setAttribute('aria-label','Productdetails');
    const id = 'rb-details-' + (++tabSequence);
    const panels = [description,specs];
    const buttons = ['Beschrijving','Specificaties'].map((label,index) => {
      const button=document.createElement('button');button.type='button';button.textContent=label;
      button.id=id+'-tab-'+index;button.setAttribute('role','tab');button.setAttribute('aria-controls',id+'-panel-'+index);
      panels[index].id=id+'-panel-'+index;panels[index].setAttribute('role','tabpanel');panels[index].setAttribute('aria-labelledby',button.id);
      panels[index].className='rb-detail-panel';panels[index].tabIndex=0;nav.append(button);return button;
    });
    const select = index => {
      buttons.forEach((button,i)=>{button.setAttribute('aria-selected',String(i===index));button.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
    };
    buttons.forEach((button,index)=>{
      button.addEventListener('click',()=>select(index));
      button.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?1:1-index;select(next);buttons[next].focus();
      });
    });
    root.replaceChildren(nav,...panels);select(0);
  }
  function init(scope=document) {scope.querySelectorAll('[data-rb-product-description]').forEach(root=>{format(root);tabs(root);});}
  window.RBNLProductDetails={format,loadSpecs,shipping,table,tabs};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
